import {IonRouterOutlet, IonSplitPane, useIonViewWillEnter, useIonViewWillLeave} from "@ionic/react";
import {IonReactRouter} from "@ionic/react-router";
import {Link, Redirect, Route} from "react-router-dom";
import SideMenu from "../sideMenu/SideMenu";
import {SubPages, Tabs, tabRoutes, subPageRoutes, tabsAndChildrenRoutes} from "./AllRoutes";
import {useStoreState} from "pullstate";
import {AuthStore, initAuth} from "../../store/Common_Store";
import {getPageData} from "../../store/Selectors";
import {Fragment, Suspense, useEffect, useState} from "react";
import {useSideMenuOptions} from "../sideMenu/SideMenuProvider";
import Loading from "../../pages/Loading";
import queryString from "query-string";
import _ from "../../_";

function NotFound() {
    useIonViewWillEnter(() => {
        _._seo.setSeo404Meta();
    });
    useIonViewWillLeave(() => {
        _._seo.setSeoDefaultMeta();
    });

    return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
            <h1>404 - Page Not Found</h1>
            <p>Oops! The page you are looking for does not exist.</p>
            {/* Link brings the user safely back to the home page */}
            <Link to="/">Go Back Home</Link>
        </div>
    );
}

const NavRoutes = () => {
    const [, setForceRender] = useState<number>(0);
    const forceRender = (triggerLoad = false) => {
        setForceRender(s => s + 1);
    }

    (window as any).testme = forceRender;

    // const authStore = useStoreState(AuthStore, getPageData);
    // const hasAuthed = authStore?.signBy ?? false;
    // const Item_會員 = hasAuthed ? authStore?.AuthData : undefined;

    const sideMenu: any = useSideMenuOptions();

    // useEffect(() => {
    //     forceRender();
    // }, [Item_會員]);
    // key={Item_會員?.會員Id}

    // let {sm = null}: {
    //     sm: string | null,
    // } = queryString.parse(window.location.search) as any;
    //
    // if (sm) {
    //     return <>
    //         <IonReactRouter>
    //             <Suspense fallback={null}>
    //                 <Fragment key={`slim_${(Item_會員?.會員Id) ?? "-"}`}>
    //                     <Route path="/tabs" render={() => <Tabs/>}/>
    //                     <SubPages/>
    //                 </Fragment>
    //             </Suspense>
    //         </IonReactRouter>
    //     </>
    // }


    //key={`normal_${(Item_會員?.會員Id) ?? "-"}`}
    return <>
            <IonReactRouter>
                <IonSplitPane contentId="main" disabled={sideMenu.disableSideMenu}>
                    <SideMenu/>
                    {/*{hasAuthed &&*/}
                    {/*    */}
                    {/*}*/}

                    <IonRouterOutlet id="main">
                        {/*<Suspense fallback={null}>*/}
                        {/*    <Fragment>*/}
                        {/*        */}
                        {/*        /!*<Route exact path="/404" render={()=> <NotFound />} />*!/*/}
                        {/*    </Fragment>*/}
                        {/*</Suspense>*/}

                        <Route path="/tabs" render={() => <Tabs/>}/>
                        <SubPages/>
                        {/*<Route path="/" component={subPageRoutes.filter(t => t.default)[0].component} exact={true}/>*/}
                        <Route exact path="/404" render={()=> <NotFound />} />
                        <Redirect exact from="/" to={tabRoutes.filter(t => t.default)[0].path.toString()}/>
                        {/*<Redirect path="*" to="/404"/>*/}
                        {/*<Route exact path="*" render={()=> <NotFound />} />*/}
                    </IonRouterOutlet>
                </IonSplitPane>
            </IonReactRouter>
    </>
}

export default NavRoutes;



